<script setup lang="ts">
  import { parseDate } from '@internationalized/date';
  import type { CalendarDate } from '@internationalized/date';
  import { shallowRef } from 'vue';

  import { DateSelect } from '@ui/components/date';

  const props = defineProps<{ val?: string }>();

  const emit = defineEmits<{
    (e: 'resolve', value: string): void;
  }>();

  const safeParse = (s?: string): CalendarDate | null => {
    if (!s) return null;
    try {
      return parseDate(s);
    } catch {
      return null;
    }
  };

  const date = shallowRef<CalendarDate | null>(safeParse(props.val));

  const onUpdate = (next: CalendarDate | null) => {
    date.value = next;
    if (!next) return;
    const value = next.toString();
    if (value === props.val) return;
    emit('resolve', value);
  };
</script>

<template>
  <DateSelect
    class="w-full bg-background"
    size="sm"
    :model-value="date"
    @update:model-value="onUpdate"
  />
</template>
